import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Icon from '@/components/base/Icon';
import { gettext } from '@/utils/langsBook';
var ListHeaderStyled = styled.div.withConfig({
    displayName: "ListHeader__ListHeaderStyled",
    componentId: "sc-o0ulny-0"
})([
    "",
    " .header{",
    " .title{",
    "}.desc{",
    "}}"
], {
    "paddingTop": "24px",
    "paddingBottom": "24px"
}, {
    "marginBottom": "12px",
    "position": "relative",
    "display": "flex"
}, {
    "fontSize": "24px",
    "lineHeight": "29px",
    "fontWeight": "600",
    "flex": "1 1 0%"
}, {
    "fontSize": "14px",
    "lineHeight": "17px",
    "color": "var(--color-desc-text)",
    "display": "flex",
    "alignItems": "center",
    "marginRight": "10px",
    "alignSelf": "flex-end"
});
var ListHeader = function(props) {
    var ref = props || {}, title = ref.title, desc = ref.desc, total = ref.total, children = ref.children;
    return(/*#__PURE__*/ _jsxs(ListHeaderStyled, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "header",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "title",
                        children: gettext(title)
                    }),
                    desc ? /*#__PURE__*/ _jsxs("div", {
                        className: "desc",
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                type: "bar",
                                className: "text-[16px] mr-[8px]"
                            }),
                            total,
                            " ",
                            gettext(desc)
                        ]
                    }) : ''
                ]
            }),
            children
        ]
    }));
};
export default ListHeader;
